import React from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import { get } from 'lodash-es';
import { ROUTE_TO_ADMIN_EMPLOYEES_LIST_PAGE, ROUTE_TO_ADMIN_EDIT_EMPLOYEE_PAGE } from '../../../constants/routes';
import { Query } from 'react-apollo';
import { handleRequestError } from '../../../constants/errorCodes';
import { GetSingleEmployeeQuery } from '../../../operations/queries/GetUsersQuery';
import { AdminEditContainer } from '../../../components/AdminEditUserTabs/AdminEditContainer';

export const AdminEditEmployeePage = () => {
  const params = useParams();
  const userId = parseInt(get(params, 'userId', null), 10);
  const dispatch = useDispatch();

  return (
    <Query
      query={GetSingleEmployeeQuery}
      variables={{ id: userId }}
      onError={error => handleRequestError(error, dispatch)}
      fetchPolicy="network-only"
    >
      {({ loading, data, error }) => {
        if (loading || (!data && !error)) {
          return null;
        }

        if (get(data, 'getSingleUser.users.length', 0) < 1) {
          return <Redirect to={ROUTE_TO_ADMIN_EMPLOYEES_LIST_PAGE} />;
        }

        const user = get(data, 'getSingleUser.users[0]', null);

        return (
          <AdminEditContainer
            user={user}
            userId={userId}
            baseRoute={ROUTE_TO_ADMIN_EDIT_EMPLOYEE_PAGE}
            backRoute={ROUTE_TO_ADMIN_EMPLOYEES_LIST_PAGE}
            isEmployee={true}
          />
        );
      }}
    </Query>
  );
};
